import { useMediaQuery } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import Toolbar from "./toolbar/Toolbar";
import NavigationList from "./NavigationList";

import clsx from "clsx";
import AppBar from "@material-ui/core/AppBar";
import IconButton from "@material-ui/core/IconButton";
import List from "@material-ui/core/List";

import logo from "../../../assets/images/logo.svg";
import materialNav from "./materialNavStyle";
import { StyledDrawer, StyledDrawerOpen, StyledSidebarLogo } from "./styledNavigation";

const Navigation = ({ setAuthentication, roleClient, roleAdmin }) => {

  const classes = materialNav();
  const [open, setOpen] = useState(true);
  const isMobile = useMediaQuery("(max-width:599px)");

  const [windowSize, setWindowSize] = useState({
    width: null
  });

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth
      });
    };

    window.addEventListener("resize", handleResize);
    handleResize();
    if (windowSize.width <= 1280) {
      handleDrawerClose();
    } else {
      handleDrawerOpen();
    }
  }, [windowSize.width]);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const mobileClose = () => {
    if (windowSize.width <=600) {
      setOpen(false);
    }
  }

  return (
    <>
      <AppBar
        position="fixed"
        className={clsx(classes.appBar, { [classes.appBarShift]: open })}
      >
        <Toolbar sidebar={open} handleDrawerOpen={handleDrawerOpen} setAuthentication={setAuthentication} />
      </AppBar>
      <StyledDrawer
        variant={isMobile ? "temporary" : "permanent"}
        open={open}
        onClose={handleDrawerClose}
        className={clsx(classes.drawer, { [classes.drawerOpen]: open, [classes.drawerClose]: !open })}
        classes={{ paper: clsx({ [classes.drawerOpen]: open, [classes.drawerClose]: !open }) }}
      >
        <div className={classes.toolbar}>
          <StyledDrawerOpen>
            <StyledSidebarLogo className="sidebar-logo" as={NavLink} to="/">
              <img src={logo} alt="logo" className="sidebar-logo__icon" />
              <h5 className="sidebar-logo__title">Control Panel</h5>
            </StyledSidebarLogo>
            <IconButton className="sidebar__arrow-bar" onClick={handleDrawerClose}>
              <span className="icon-light-chevron-left" />
            </IconButton>
          </StyledDrawerOpen>
        </div>
        <List className="sidebar-menu">
          <NavigationList mobileClose={mobileClose} />
          {/*<NavItem title="Выход" icon="exit" onClick={logout}/>*/}
        </List>
      </StyledDrawer>
    </>
  );
};

export default Navigation;


